(function () {
    var hdr = document.querySelector('[data-mlh]');
    if (!hdr) return;

    /* ---- condense on scroll ----
       Hysteresis, not one threshold. Condensing changes the header's height,
       and the header is sticky rather than fixed, so it stays in flow and the
       browser's scroll anchoring nudges the scroll position to compensate.
       With a single 12px threshold that nudge landed back on the other side of
       it: the class flipped every frame and an upward scroll could not get
       past roughly 13px, which is the flicker people were seeing on the way
       back to the top. The band has to be comfortably wider than the height
       change that causes the nudge. */
    if (hdr.dataset.sticky === 'true') {
      var ON_AT = 72;
      var OFF_AT = 24;
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var y = window.pageYOffset;
          var on = hdr.classList.contains('is-scrolled');
          if (!on && y > ON_AT) {
            hdr.classList.add('is-scrolled');
          } else if (on && y < OFF_AT) {
            hdr.classList.remove('is-scrolled');
          }
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- search panel ---- */
    var sBtn = hdr.querySelector('[data-mlh-search-toggle]');
    var sPanel = hdr.querySelector('#mlh-search-panel');
    if (sBtn && sPanel) {
      sBtn.addEventListener('click', function () {
        var open = sPanel.classList.toggle('is-open');
        sBtn.setAttribute('aria-expanded', String(open));
        if (open) {
          var f = sPanel.querySelector('input[type="search"]');
          if (f) f.focus();
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sPanel.classList.contains('is-open')) {
          sPanel.classList.remove('is-open');
          sBtn.setAttribute('aria-expanded', 'false');
          sBtn.focus();
        }
      });
    }

    /* ---- hover-open the theme's own <details> submenus on pointer devices.
       details-disclosure.js only opens them on click, which reads as clunky
       next to the catalog panel. Click still works, and touch is untouched. ---- */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var subs = hdr.querySelectorAll('.mlh__nav details');
      Array.prototype.forEach.call(subs, function (dt) {
        var li = dt.closest('li') || dt;
        var t = null;
        li.addEventListener('mouseenter', function () {
          window.clearTimeout(t);
          dt.setAttribute('open', '');
        });
        li.addEventListener('mouseleave', function () {
          t = window.setTimeout(function () { dt.removeAttribute('open'); }, 160);
        });
        dt.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { dt.removeAttribute('open'); }
        });
      });
    }

    /* ---- a top-level submenu is a full-width bar, so its items are padded
       across to line up under the tab that opened them ---- */
    function directChild(el, sel) {
      for (var i = 0; i < el.children.length; i++) {
        if (el.children[i].matches(sel)) return el.children[i];
      }
      return null;
    }
    function alignSubmenu(dt) {
      var panel = directChild(dt, '.header__submenu');
      var summary = directChild(dt, 'summary');
      if (!panel || !summary) return;
      /* Line the first item's TEXT up with the tab's text. Read both paddings
         rather than hardcoding them: the tab's shrinks at narrower breakpoints,
         which a fixed offset got wrong by 5-7px. */
      var first = panel.querySelector('.header__menu-item');
      var padSummary = parseFloat(window.getComputedStyle(summary).paddingLeft) || 0;
      var padItem = first ? parseFloat(window.getComputedStyle(first).paddingLeft) || 0 : 0;
      var offset = summary.getBoundingClientRect().left - hdr.getBoundingClientRect().left
                 + padSummary - padItem;
      panel.style.setProperty('--mlh-sub-offset', Math.max(0, Math.round(offset)) + 'px');
    }
    var topDetails = hdr.querySelectorAll('.mlh__nav .list-menu--inline > li > header-menu > details');
    Array.prototype.forEach.call(topDetails, function (dt) {
      /* `toggle` fires however it opened: hover, click or keyboard */
      dt.addEventListener('toggle', function () { if (dt.open) alignSubmenu(dt); });
    });
    window.addEventListener('resize', function () {
      Array.prototype.forEach.call(topDetails, function (dt) { if (dt.open) alignSubmenu(dt); });
    }, { passive: true });

    /* ---- catalog mega panel, hung off the Catalog nav item ---- */
    var mega = hdr.querySelector('[data-mlh-mega]');
    var nav = hdr.querySelector('.mlh__nav');
    if (!mega || !nav) return;

    var wanted = hdr.dataset.catalogTrigger || 'Catalog';
    /* only top-level items, so a child link called Catalog cannot win */
    var trigger = null;
    var want = String(wanted).trim().toLowerCase();
    var topItems = nav.querySelectorAll('.list-menu--inline > li');
    for (var i = 0; i < topItems.length; i++) {
      var el = topItems[i].querySelector('summary') || topItems[i].querySelector('a');
      if (!el) continue;
      if ((el.textContent || '').trim().toLowerCase() === want) { trigger = el; break; }
    }
    if (!trigger) return;

    mega.removeAttribute('hidden');
    if (!trigger.querySelector('.icon-caret')) {
      var caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      caret.setAttribute('class', 'icon icon-caret');
      caret.setAttribute('viewBox', '0 0 10 6');
      caret.setAttribute('fill', 'none');
      caret.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M1 1L5 5L9 1');
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', '1.5');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      caret.appendChild(path);
      trigger.appendChild(caret);
    }
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    if (!mega.id) mega.id = 'mlh-catalog-panel';
    trigger.setAttribute('aria-controls', mega.id);

    var closeTimer = null;
    var isOpen = false;
    var dismissed = false;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function open() {
      window.clearTimeout(closeTimer);
      /* Escape sets `dismissed` so returning focus to the trigger cannot
         immediately reopen the panel. Moving the pointer away clears it. */
      if (dismissed || isOpen) return;
      isOpen = true;
      hdr.classList.add('mlh--mega-open');
      trigger.classList.add('mlh-trigger-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      hdr.classList.remove('mlh--mega-open');
      trigger.classList.remove('mlh-trigger-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function closeSoon() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, 180);
    }

    if (canHover) {
      trigger.addEventListener('mouseenter', open);
      trigger.addEventListener('mouseleave', function () { dismissed = false; closeSoon(); });
      mega.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', closeSoon);
    }

    /* touch and keyboard: first activation opens the panel rather than navigating,
       a second activation follows the link */
    trigger.addEventListener('click', function (e) {
      if (canHover && isOpen) return;
      if (!isOpen) { e.preventDefault(); dismissed = false; open(); }
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        dismissed = false;
        open();
        var first = mega.querySelector('a');
        if (first) first.focus();
      }
    });
    trigger.addEventListener('focus', function () { if (canHover) open(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) { dismissed = true; close(); trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (isOpen && !mega.contains(e.target) && !trigger.contains(e.target)) close();
    });
    mega.addEventListener('focusout', function (e) {
      if (!mega.contains(e.relatedTarget) && e.relatedTarget !== trigger) close();
    });

    /* ---- category row: fade hint, and mark the one you are viewing ---- */
    var catRow = mega.querySelector('[data-mlh-catrow]');
    var catScroll = mega.querySelector('[data-mlh-catscroll]');
    if (!catScroll) return;

    var cats = [].slice.call(catScroll.querySelectorAll('[data-mlh-cat]'));

    function fades() {
      catRow.classList.toggle('has-overflow', catScroll.scrollWidth - catScroll.clientWidth - catScroll.scrollLeft > 4);
    }

    /* is-active marks the category you are currently browsing, matched on the
       tag filters in the URL. Hover is a colour change only, handled in CSS. */
    cats.forEach(function (a) { a.classList.remove('is-active'); });
    try {
      var active = new URLSearchParams(window.location.search).getAll('filter.p.tag');
      if (active.length) {
        for (var c = 0; c < cats.length; c++) {
          var tags = (cats[c].dataset.mlhTags || '').split(',').map(function (x) { return x.trim(); });
          if (tags.some(function (t) { return t && active.indexOf(t) !== -1; })) {
            cats[c].classList.add('is-active');
            cats[c].scrollIntoView({ block: 'nearest', inline: 'center' });
            break;
          }
        }
      }
    } catch (e) {}

    fades();
    catScroll.addEventListener('scroll', fades, { passive: true });
    if (window.ResizeObserver) {
      new ResizeObserver(fades).observe(catScroll);
    } else {
      window.addEventListener('resize', fades);
    }
  })();
